import type { Breakpoints } from '../../types'
import {
  SbBreakpointsLarge,
  SbBreakpointsMedium,
  SbBreakpointsXlarge,
} from './generated-tokens/ts/breakpoints'

export const breakpoints: Breakpoints = {
  medium: SbBreakpointsMedium,
  large: SbBreakpointsLarge,
  xLarge: SbBreakpointsXlarge,
}
